import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    textField: {
      '& .MuiSelect-icon': {
        right: 32,
      },
      '& .MuiSelect-root': {
        fontSize: 11,
        paddingLeft: 8,
      },
      '& .MuiMenuItem-root': {
        fontSize: 11,
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.blue,
      },
      '& .MuiFormLabel-root.Mui-focused': {
        color: palette.blue,
      },
    },
    smallFontSize: {
      fontSize: 11,
    },
    closeIcon: { color: palette.red, fontSize: 15, cursor: 'pointer' },
  });
